import { createModel } from 'xstate/lib/model';

import baseEvents from 'features/Bento/libs/machines/config/baseEvents';

type ResearchExperimentModuleData = {
  uid: string;
  isMobile: boolean;
};

const context = {
  getModuleData: (() => {
    throw new Error('NOT_IMPLEMENTED');
  }) as () => ResearchExperimentModuleData,
};

export type Context = typeof context;

const model = createModel(
  context,

  {
    events: {
      ...baseEvents,

      ACCEPT_RESEARCH_EXPERIMENT: () => ({}),
      CANCEL_RESEARCH_EXPERIMENT: () => ({}),
      DECLINE_RESEARCH_EXPERIMENT: () => ({}),
      'done.invoke.evaluateResearchExperimentEligibility': (data: boolean) => ({
        data,
      }),
    },
  },
);

export type Model = typeof model;

export default model;
